import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TiposMenuEnum } from '@appNeo/core/helpers/enums/tiposMenuEnum';
import { IInvitado } from '@appNeo/core/interfaces/IInvitado';
import { BYPASS_FRONT_TOKEN } from '@appNeo/neoCore/interceptors/jwt/jwt.interceptor';
import { DISABLE_DELAY_LOADER } from '@appNeo/neoCore/interceptors/loaderInterceptor/loader.interceptor';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { IFicheroExtendido } from '@appNeo/neoShared/helpers/interfaces/IFichero';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { Paginator } from '@appNeo/neoShared/models/paginator/paginator';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { botoneraAccionesImgGenerica, UtilidadesLayoutService } from '@appNeo/neoShared/services/utilidades/utilidades-layout.service';
import { environment } from '@environments/environment';
import { catchError, forkJoin, map, Observable, of, Subject, tap, throwError } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { MenusAdminService } from '../menus-admin/menus-admin.service';
import { ReservaAdminService } from '../reservaAdmin/reserva-admin.service';

@Injectable({
  providedIn: 'root'
})
export class InvitadosAdminService {

  // public editando$ = new BehaviorSubject<boolean>(false);

   contextLoader = { context: new HttpContext().set(DISABLE_DELAY_LOADER, true) };
   urlEntidad = environment.api_base_url_backoffice + '/reserva';
  public editandoReservaMenus$ = new BehaviorSubject<boolean>(false);
  public editandoCheckin$ = new BehaviorSubject<boolean>(false);

  public error422Api$: Subject<IRespApi> = new Subject<IRespApi>();
  public invitados$: BehaviorSubject<IInvitado[]> = new BehaviorSubject<IInvitado[]>(null);
  public totalInvitados$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService,
    private utilidadesLayoutService: UtilidadesLayoutService,
    private reservaService: ReservaAdminService,
    private menusService: MenusAdminService,
    private router: Router
  ) { }

  set editandoReservaMenus(editandoReservaMenus: boolean) {
    this.editandoReservaMenus$.next(editandoReservaMenus);
  }

  set editandoCheckin(editandoCheckin: boolean) {
    this.editandoCheckin$.next(editandoCheckin);
  }

  getAll(id: string, tipoPaginador?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any, contextFront = true): Observable<IInvitado[]> {
    let request = (tipoPaginador === TipoPaginadorEnum.offline)
      ? `${this.urlEntidad}/${id}/invitados/?${this.auxiliar.extraerFiltros(filtros)}`
      : `${this.urlEntidad}/${id}/invitados/?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    let context = {};
    contextFront ? context = {} : {};
    return this.http.get(request, {}).pipe(
        tap( (data: IRespApi )=> console.log('Debug data invitados', data)),
        tap( (data: IRespApi )=> this.totalInvitados$.next( data.total )),
        tap( (data: IRespApi )=> this.invitados$.next( this.mapearEntidades(data.data) )),
      map((data: IRespApi) => this.mapearEntidades(data.data)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestAllInvitados');
      })
    );
  }

  // get(id): Observable<IInvitado>{
  //   return this.http.get(`${this.urlEntidad}/${id}`).pipe(
  //     map(  (data: IRespApi) =>  this.mapearEntidad(data['data']) )
  //   );
  // }

  mapearEntidades( extras: IInvitado[] ) {
    if (extras.length) {
      extras.forEach((element, index )=> {
        extras[index] = this.mapearEntidad( element );
      });
    }
    return extras;
  }

  mapearEntidad( entidad: IInvitado ):IInvitado{
    // let fechaFormatt = new Date(item?.fecha);
    // let fechaFormatt = this.datepipe.transform(item?.fecha, 'dd/MM/yyyy');
    // let importeFormatt = item.importe.toFixed(2);
    // let item = Object.assign({}, entidad);
    // if (item['activo']) {
    //   item['activo'] = this.auxiliar.getBoolean(item['activo']);
    // }
    // let camposTraduccion = {};
    // if(item.idiomas) {
    //   camposTraduccion = this.auxiliar.obtenerContenidoPorIdioma(item.idiomas);
    // }
    // let _item = {...item, ...camposTraduccion};
    // let miniaturaListado;
    // if ( _item?.miniaturas && _item?.miniaturas['_mini/listado']) {
    //   miniaturaListado = _item.miniaturas['_mini/listado'];
    // }

    // if (miniaturaListado) _item['ruta'] = miniaturaListado;
    // return _item;
    return entidad;
  }

  create(codigoReserva: string, request: any): Observable<any>{
    return this.http.post<IRespApi>( `${this.urlEntidad}/${codigoReserva}/invitados`, request, {}) .pipe(
      map( (resp: IRespApi) => resp.data),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestPostInvitado');
      })
    );

  }

  update(codigoReserva: string, id: string, request: any, contextFront = true) {
    let context = {};
    contextFront ? context = {} : {};
    return this.http.put( `${this.urlEntidad}/${codigoReserva}/invitados/${id}`, request, context).pipe(
      map((data: IRespApi) => data['data']),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestPutInvitado');
      })
      );
  }

  delete(codigoReserva: string, id:string) {
    return this.http.delete( `${this.urlEntidad}/${codigoReserva}/invitados/${id}` , {}).pipe(
      map((valor: string) => this.auxiliar.getBoolean(valor)),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestDeleteInvitado');
      })
    );
  }

  confirmarCheckin(idReserva: string, request) {
    console.log('DEBUG ID RESERVA', idReserva, request);
    return this.http.post<IRespApi>( `${this.urlEntidad}/${idReserva}/confirmarCheckIn`, request, {}) .pipe(
      map( (resp: IRespApi) => resp.data),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestPostInvitadoConfirmarCheckin');
      })
    );
  }

  desconfirmarCheckin(idReserva: string, request) {
    return this.http.post<IRespApi>( `${this.urlEntidad}/${idReserva}/desconfirmarCheckIn`, request, {}) .pipe(
      map( (resp: IRespApi) => resp.data),
      catchError( (err: IRespApi) => {
        return this.handleError( err,  'IRequestPostInvitadoDesConfirmarCheckin');
      })
    );
  }


  // eliminarImagenPrincipal(idExtra: string) {
  //   return this.http.delete(`${this.urlEntidad}imagenPrincipal/${idExtra}`).pipe(
  //     map((data: IRespApi) => data));
  // }

  // editarImagenPrincipal(idExtra: string, request: any): Observable<any> {
  //   return this.http.post<IRespApi>( `${this.urlEntidad}/${idExtra}/ficheros`, request ) .pipe(
  //     map( (resp: IRespApi) => resp.data),
  //     catchError( (err: IRespApi) => {
  //       return this.handleError( err,  'IRequestPostExtra');
  //     })
  //   );
  // }

  // editarCamposImagenPrincipal(idExtra: string, request: any): Observable<any> {
  //   return this.http.patch<IRespApi>( `${this.urlEntidad}/${idExtra}/ficheros`, request ) .pipe(
  //     map( (resp: IRespApi) => resp.data),
  //     catchError( (err: IRespApi) => {
  //       return this.handleError( err,  'IRequestPatchExtra');
  //     })
  //   );
  // }

  getConfiguracionFicheros(clave: string) {
    return this.http.get(`${this.urlEntidad}/configuracionFicheros/${clave}`).pipe(
      map(  (data: IRespApi) =>  this.utilidadesLayoutService.getConfiguracionFichero(data['data']) )
    );
  }

  obtenerConfiguracionCamposMultimedia() {
    let peticion = {
      tamanoMaximoFichero: this.getConfiguracionFicheros('ficheros_maxTamanoFichero'),
      formatosPermitidos: this.getConfiguracionFicheros('ficheros_formatos'),
    };
    return forkJoin(peticion);
  }


  /************************************
  * Funciones apoyo                  *
  *************************************/
   resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
     // TODO: Ajustar, código provisional por conflictos token entre parte pública invitados y admin checkin
     let peticion = {};
     let idReserva = route.params.id;
     if (idReserva) {
         peticion['reserva'] = this.reservaService.get(idReserva).pipe(
          catchError(err => of(err))
        )
         peticion['listadoEntidad'] = this.getAll(idReserva).pipe(
          catchError(err => of(err))
        )
       peticion['menusAdultos'] = this.reservaService.menusDisponibles(idReserva, TiposMenuEnum.Padres).pipe(catchError(err => of(err)));
       peticion['menusNinos'] = this.reservaService.menusDisponibles(idReserva, TiposMenuEnum.Ninos).pipe(catchError(err => of(err))); 
     }
    //  peticion['menusAdultos'] = this.menusService.getByTipoMenu(TiposMenuEnum.Padres).pipe(catchError(err => of(err)));
    //  peticion['menusNinos'] = this.menusService.getByTipoMenu(TiposMenuEnum.Ninos).pipe(catchError(err => of(err)));   


     return forkJoin(peticion);
  }

  private handleError(err: IRespApi, idRequest = '') {
    // control error server con un html ok
    if (err == 'OK') {
      let mensaje = environment.errorServidorSinCodigo;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    // dialog específico
    if ( err.codigoError === 422) {
      err.request = idRequest;
      this.error422Api$.next(err);
    }

    // pantalla común
    let mensaje = err?.mensaje;
    if ( err.codigoError === 403) {
      mensaje = `${ err.mensaje }: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if ( err.data ) {
        if ( typeof err.data === 'string') {
          avisos = err.data;
        } else {
          err.data.forEach(element => {
            if ( element.id === 999 ) {
              avisos = ' ' + element.mensaje + ' ';
            }
          });
        }
      }
      mensaje = err?.mensaje +  avisos;
    }
    return throwError({'error' : true, 'data': err.data, mensaje });
  }
}
